import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { getAdvisoryArticles } from '@xing-com/crate-lebenslauf-articles';
import { ArticleCard, MetaData } from '@xing-com/crate-lebenslauf-components';
import {
  useIsCrateApp,
  useIsCoverLetterRoot,
  useVitaTracking,
} from '@xing-com/crate-lebenslauf-hooks';

import {
  StyledAdvisory,
  StyledAdvisoryHeader,
  StyledArticles,
  StyledHero,
  StyledBodyCopy,
  StyledListTitle,
} from './advisory.styled';
import { getMeta } from './meta';

export const Advisory: React.FC = () => {
  const { trackPageView, trackWithNWT } = useVitaTracking({
    pageName: 'advisory',
  });
  const { formatMessage } = useIntl();
  const isCrateApp = useIsCrateApp();
  const isCoverLetterRoot = useIsCoverLetterRoot();

  const articles = getAdvisoryArticles(isCoverLetterRoot, isCrateApp);
  const { title, description } = getMeta(isCoverLetterRoot);

  React.useEffect(() => {
    trackWithNWT();
    trackPageView();
  }, [trackPageView, trackWithNWT]);

  return (
    <StyledAdvisory>
      <MetaData title={title} description={description} />

      <StyledAdvisoryHeader>
        <div>
          <StyledHero size="large">
            <FormattedMessage id="CRATE_LEBENSLAUF_ADVISORY_PAGE_TITLE" />
          </StyledHero>
          <StyledBodyCopy size="xlarge">
            <FormattedMessage id="CRATE_LEBENSLAUF_ADVISORY_PAGE_DESCRIPTION" />
          </StyledBodyCopy>
        </div>
      </StyledAdvisoryHeader>
      <StyledListTitle>
        <FormattedMessage
          id={
            isCoverLetterRoot
              ? 'CRATE_COVER_LETTER_ADVISORY_PAGE_LIST_TITLE'
              : 'CRATE_LEBENSLAUF_ADVISORY_PAGE_LIST_TITLE'
          }
        />
      </StyledListTitle>

      <StyledArticles>
        {articles.map((article) => (
          <ArticleCard
            key={article.url}
            {...{
              title: article.title,
              description: article.description,
              to: article.url,
              image: article.image?.srcWide ?? '',
              buttonCopy: formatMessage({
                id: 'CRATE_LEBENSLAUF_ADVISORY_PAGE_READ_MORE',
              }),
            }}
          />
        ))}
      </StyledArticles>
    </StyledAdvisory>
  );
};
